<template>
  <div>
    <md-field
      style="background-color: rgb(240, 240, 242);padding-bottom: 0"
      v-for="(item, index) in list"
      :key="index"
    >
      <md-input-item
        title="物品名稱"
        :value="item.name"
        placeholder="請選擇"
        :disabled="!showadd"
        @focus="getname(index)"
      >
        <span
          slot="right"
          style="margin-right: 0.15rem;margin-top: -0.2rem;color: rgba(48, 125, 253, 1)"
          v-if="list.length > 1 && showadd"
          @click="delet(index)"
          >删除</span
        >
      </md-input-item>
      <md-input-item
        title="物品價值"
        type="money"
        @blur="getAllvalue"
        v-model="item.price"
        :disabled="!showadd && !addshow"
        :class="!showadd && addshow ? 'inpur' : ''"
        placeholder="請輸入物品價值"
      >
        <span slot="right" style="margin-right: 0.15rem;">
          (人民币) CNY
        </span>
      </md-input-item>
      <md-field-item title="物品數量">
        <md-stepper
          v-model="item.num"
          min="1"
          :disabled="!showadd"
          @change="getAllvalue"
          :read-only="!showadd"
        />
      </md-field-item>
      <md-input-item
        title="商品鏈接"
        readonly
        v-if="
          conuntrycode == 'JP' &&
            conuntrycode.isGoodsLink == 1 &&
            !showadd &&
            !addshow
        "
      >
        <div slot="left">
          <md-tip :content="item.url" placement="top">
            <md-button type="link">查看</md-button>
          </md-tip>
        </div>
      </md-input-item>
      <md-input-item
        title="商品鏈接"
        :value="item.url"
        placeholder="添加"
        @focus="geturl(index)"
        v-else-if="conuntrycode.code == 'JP' && conuntrycode.isGoodsLink == 1"
      >
      </md-input-item>
    </md-field>

    <md-button
      type="primary"
      icon="edit"
      plain
      style="width: 90%;margin: 0.2rem 0 0 5%;margin-bottom: 1.5rem;background-color: white"
      @click="addshop"
      v-if="showadd"
      >新增貨品</md-button
    >
    <div style="width: 100%;height: 1.5rem"></div>
    <div class="bootomContaine" v-if="addshow">
      <p>
        物品總值：<span>{{ allprice }} CNY</span>
      </p>
      <div class="btn" @click="allsumbmit">
        <span>確定</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  InputItem,
  Field,
  Icon,
  Tip,
  Stepper,
  FieldItem,
  Button,
  Toast
} from "mand-mobile";
export default {
  name: "GoodlistModal",
  components: {
    [Button.name]: Button,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Tip.name]: Tip,
    [FieldItem.name]: FieldItem,
    [Stepper.name]: Stepper
  },
  data() {
    return {
      addshow: true,
      allprice: 0.0,
      showadd: true,
      conuntrycode: {},
      list: [
        {
          id: "",
          name: "",
          num: 1,
          price: "",
          url: ""
        }
      ],
      isCheck: false
    };
  },
  activated() {
    if (this.isCheck) {
      this.showadd = true;
      this.addshow = true;
    } else {
      if (this.$route.query.status && this.$route.query.status != undefined) {
        if (this.$route.query.status == 11) {
          this.showadd = false;
          this.addshow = true;
        } else if (this.$route.query.status == 14) {
          this.showadd = true;
          this.addshow = true;
        } else {
          this.showadd = false;
          this.addshow = false;
        }
      } else {
        this.showadd = true;
        this.addshow = true;
      }
    }
    console.log('ee',this.$route.query.status,this.showadd,this.list);
  },
  methods: {
    isCheckBack() {
      // isCheck 回调
      this.isCheck = true;
      this.showadd = true;
      this.addshow = true;
      console.log(this)
    },
    ishuri(){
   this.isCheck = false;
      this.showadd = false;
      this.addshow = false;
    },
    delet(e) {
      this.list[e].id ? this.parcel(this.list[e].id) : null;
      this.list.splice(e, 1);
      this.getAllvalue();
    },
    addshop() {
      const item = {
        id: "",
        name: "",
        num: 1,
        price: "",
        url: ""
      };
      this.list.push(item);
    },
    getname(index) {
      this.$router.push({
        name: "Goodname",
        query: {
          index: index
        }
      });
    },
    geturl(index) {
      this.$router.push({
        name: "GoodUrl",
        query: {
          index: index,
          url: this.list[index].url
        }
      });
    },
    allsumbmit() {
      var fititename = this.list.findIndex((value, index, obj) => {
        return !value.name;
      });
      if (fititename >= 0) {
        Toast.failed("第" + (fititename + 1) + "条物品資訊請選擇物品名稱");
        return;
      }
      var fititeprice = this.list.findIndex((value, index, obj) => {
        return !value.price;
      });
      if (fititeprice >= 0) {
        Toast.failed("第" + (fititeprice + 1) + "条物品資訊請輸入物品價值");
        return;
      }
      var fititeurl = this.list.findIndex((value, index, obj) => {
        return !value.url;
      });
      if (
        fititeurl >= 0 &&
        this.conuntrycode.goodsLinkRequired == 1 &&
        this.conuntrycode.code == "JP"
      ) {
        Toast.failed("第" + (fititeprice + 1) + "条物品資訊請輸入商品鏈接");
        return;
      }
      this.$emit("submitform");
    },
    getAllvalue() {
      var price = this.sum(this.list);
      this.allprice = price.toFixed(2);
    },
    sum(arr) {
      var s = 0;
      arr.forEach(function(val, idx, arr) {
        s += val.price * val.num;
      }, 0);
      return s;
    },
    parcel(id) {
      const par = {
        productId: id
      };
      this.http
        .APIASK(this.ports.deleteProduct, "delete", par)
        .then(res => {})
        .catch(err => {});
    }
  }
};
</script>

<style lang="less">
.md-field-content {
  background-color: white !important;
}
.bootomContaine {
  z-index: 99;
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: white;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  p {
    font-size: 0.32rem;
    margin-left: 0.1rem;
    span {
      color: #ff5b60;
    }
  }
  .btn {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 0.32rem;
    background-color: #ff5b60;
    width: 2rem;
  }
}

.md-field-item-title {
  width: 1.6rem !important;
}
.inpur input {
  border: 1px solid red;
  height: 80%;
}
</style>
